import { createContext, useState, useEffect, useContext} from 'react'
import { fetchResearcherDetailId } from '../api/index';

const ResearcherContext = createContext();

export const ResearcherProvider = ({ children }) => {

    const [ researcherId, setResearcherId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        const loadResearcherId = async() =>{
      try {
        const data = await fetchResearcherDetailId();
        setResearcherId(data.researcherId);
      } catch (err) {
        console.error("Failed to load researcherId", err);
      } finally {
        setLoading(false);
      }
        }
    loadResearcherId();
    }, [])
  return (
    <ResearcherContext.Provider value={{ researcherId, loading }}>
      {children}
    </ResearcherContext.Provider>
  )
}

export const useResearcher = () => useContext(ResearcherContext);